<template>
    <div class="c-product-size-scope" v-if="localItem && (localItem.StockStatus != 'PRE' && localItem.StockStatus != 'PRE2' && localItem.StockStatus != 'NO')">
        <div class="c-product-size" :class="{'is-valid' : isValid, 'is-invalid': isInvalid, 'is-disabled': isDisabled || localLoading}">
            <v-input v-if="localItem"  :disabled="isDisabled || localLoading" :horizontal="false" type="number" min="0" :name="`${_uid}-product-size`" input-size="small" :value="item.Amount" v-model.number="localItem.Amount" @change="updateItem">
                <span slot="label" class="u-text-align-center u-block u-margin-bottom-tiny">{{item.Size}}</span>
            </v-input>
        </div>

        <!-- The stock available -->
        <div v-if="typeof localItem.Stock !== 'undefined'"
             class="c-product-size__stock u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny"
             :class="{'is-valid' : isValid, 'is-invalid': isInvalid}">

            <template v-if="localItem.Stock && localItem.Stock > 0">
                <svgicon name="check" width=".8em" height=".8em" class="u-svg-color-success-base"></svgicon>
                <span v-if="!isCustomerHidden">Stock: {{ localItem.Stock }}</span>
                <span v-else>{{ localItem.StockIndication }}</span>
            </template>
            <template v-else>
                <svgicon name="cross" width=".6em" height=".6em" class="u-svg-color-alpha-base"></svgicon>
                <span>{{ localItem.StockIndication }}</span>
            </template>
            
            <span v-if="localItem.NextStockDelivery" 
                    v-tooltip="{
                    content: getFormattedNextDeliveryDate,
                    classes: 'information'
                    }">
                <svgicon name="info" width="1em" height="1em" class="u-svg-color-info-base"></svgicon>
            </span>
        </div>

        <div class="c-product-size__icons u-flex--content-center c-icon-label c-icon-label--small u-font-tiny u-margin-top-tiny" 
            :class="{'is-valid' : isValid, 'is-invalid': isInvalid}">

            <!-- The supplier stock available -->
            <template v-if="item && typeof item.SupplierStock !== 'undefined' && item.SupplierStock !== null">
                <span v-if="!isMarketing" 
                      v-tooltip="{
                        content: getFormattedStockInfoSupplier,
                        classes: 'information'
                      }">
                    <svgicon class="u-color-success-base" name="factory" width="1.3em" height="1.3em"></svgicon>
                    <span v-if="!isCustomerHidden">{{ item.SupplierStock }}</span>
                </span>
            </template>

            <!-- The amount in the basket -->
            <template v-if="item && typeof item.BasketAmount !== 'undefined' && !isMarketing">
                <span>
                    <svgicon name="shopping-cart" width="1.3em" height="1.3em"></svgicon>
                    <span>{{ item.BasketAmount }}</span>
                </span>
            </template> 

        </div>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce'
    import VInput from '@/components/form/Input'

    export default {
        components: {
            VInput,
        },
        props: {
            item: Object
        },
        data() {
            return {
                localItem: this.item,
                localLoading: false
            }
        },
        computed: {
            isValid() {
                if (this.localItem && typeof this.localItem.Stock !== 'undefined' && this.localItem.Amount > 0) {
                    if(this.localItem.StockStatus == 'STOCK' 
                    || this.localItem.StockStatus == 'STOCK2' 
                    || this.localItem.StockStatus == 'OPB' 
                    || this.localItem.StockStatus == 'NOS') {
                        return true;
                    } else {
                        return this.localItem.Amount <= this.localItem.Stock;
                    }
                }
            },
            isInvalid(){
                if (this.localItem &&typeof this.localItem.Stock !== 'undefined') {
                    if(this.localItem.StockStatus == 'ZVS' || this.localItem.StockStatus == 'ZVS2' || this.localItem.StockStatus == 'OUT') { 
                        return this.localItem.Amount > this.localItem.Stock;
                    } else {
                        return false;
                    }
                }
            },
            isDisabled(){
                return this.localItem 
                && (this.localItem.StockStatus == 'PRE' 
                    || this.localItem.StockStatus == 'PRE2' 
                    || this.localItem.StockStatus == 'NO' 
                    || ((this.localItem.StockStatus == 'ZVS' || this.localItem.StockStatus == 'ZVS2' || this.localItem.StockStatus == 'OUT') && !(this.localItem.Stock + this.localItem.SupplierStock > 0)));
            },
            getFormattedNextDeliveryDate(){
                return this.$t('customer.shop.detail.new_stock_available', {date: this.$moment(this.localItem.NextStockDelivery).format('DD-MM-YYYY')});
            },
            getFormattedStockInfoSupplier(){

                if(this.localItem.SupplierStock)
                {
                    var stock = this.localItem.SupplierStockIndication;

                    if(!this.isCustomerHidden)
                    {
                        stock = this.$t('customer.shop.detail.supplier_stock', {supplier_stock: this.localItem.SupplierStock});
                    }

                    return this.$t('customer.shop.detail.supplier_stock_delivery', {supplier_stock_indication: stock, supplier_days_to_deliver_min: this.localItem.SupplierDaysToDeliverMin, supplier_days_to_deliver_max: this.localItem.SupplierDaysToDeliverMax});

                } else {

                    if(this.localItem.NextStockSupplier)
                    {
                        return this.$t('customer.shop.detail.supplier_stock_next_delivery_date', {supplier_stock_indication: this.localItem.SupplierStockIndication, next_delivery_date: this.$moment(this.localItem.NextStockSupplier).format('DD-MM-YYYY')});
                    } else {
                        return this.localItem.SupplierStockIndication;
                    }
                }
            },
            isCustomer(){
                return !this.$store.getters.userInfo.impersonated && 
                        (this.$store.getters.userInfo.role == "Klant" || this.$store.getters.userInfo.role == "PersoneelKlant" || this.$store.getters.userInfo.role == "MarketingKlant");
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            },
            isCustomerHidden() {
              return this.$store.getters.isCustomerHidden;
            }
        },
        
        methods: {
            updateItem() {
                this.$emit('update:item', this.localItem);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-product-size {
        border: 1px dashed palette(color-neutral, light);
        padding: em($global-spacing-unit-small);

        &.is-valid{
            border-color: $color-success;
            border-style: solid;
            background-color: rgba($color-success, .05);
        }

        &.is-invalid{
            border-color: $color-error;
            border-style: solid;
            background-color: rgba($color-error, .05);
        }

        &.is-disabled{
            opacity:.5;
        }
    }

    .c-product-size__stock{
        border: 1px solid transparent;
        &.is-invalid{
            border: 1px solid $color-error;
        }
    }
</style>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-product-size {
        max-width: 120px;
        min-width: 80px;
        label {
            margin-bottom: em($global-spacing-unit-tiny);
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/product/widgets/FastOrderProductSizeInput.vue